import { ref, onMounted } from 'vue';

export function useHoverSupport() {
  const canHover = ref(false);

  onMounted(() => {
    canHover.value =
      window.matchMedia('(hover: hover)').matches &&
      window.matchMedia('(pointer: fine)').matches;
  });

  return { canHover };
}
